const getPrecioUnitario = item => {
  if (typeof item?.precioUnitario === "number") {
    return item.precioUnitario;
  }

  if (typeof item?.precioPublico === "number") {
    return item.precioPublico;
  }

  if (typeof item?.importe === "number" && item?.cantidadArticulo) {
    return item.importe / item.cantidadArticulo;
  }

  return 0;
};

export const buildComandaFromProductos = (productos = []) => {
  const detallesPorArticulo = new Map();

  productos.forEach(producto => {
    const detalleKey =
      producto?.idArticulo || producto?.idProducto || producto?.idProductoArray;

    if (!detalleKey) {
      return;
    }

    const precioUnitario = getPrecioUnitario(producto);
    const cantidadArticulo = Number(producto.cantidadArticulo) || 0;
    const comentarios =
      producto.comentarios || producto.descripcionPersonalizada || "";

    if (detallesPorArticulo.has(detalleKey)) {
      const detalleActual = detallesPorArticulo.get(detalleKey);
      detalleActual.cantidadArticulo += cantidadArticulo;
      detalleActual.importe =
        detalleActual.cantidadArticulo * detalleActual.precioUnitario;

      if (!detalleActual.comentarios && comentarios) {
        detalleActual.comentarios = comentarios;
        detalleActual.descripcionPersonalizada = comentarios;
      }

      return;
    }

    detallesPorArticulo.set(detalleKey, {
      ...producto,
      precioUnitario,
      cantidadArticulo,
      comentarios,
      descripcionPersonalizada: comentarios,
      importe: cantidadArticulo * precioUnitario,
      comandaDetalleElementos: producto.comandaDetalleElementos || [],
    });
  });

  const comandaDetalles = Array.from(detallesPorArticulo.values());

  return {
    comandaDetalles,
    importeFinal: comandaDetalles.reduce(
      (acc, detalle) => acc + detalle.precioUnitario * detalle.cantidadArticulo,
      0,
    ),
  };
};

export const mapComandaToProductos = (comanda = {}, nextId = 1) => {
  const detalles = Array.isArray(comanda.comandaDetalles)
    ? comanda.comandaDetalles
    : [];
  let nextIdProductoArray = nextId;

  const productos = detalles.map(detalle => {
    const precioUnitario = getPrecioUnitario(detalle);
    const cantidadArticulo = Number(detalle.cantidadArticulo) || 0;
    const descripcionPersonalizada =
      detalle.descripcionPersonalizada || detalle.comentarios || "";
    const producto = {
      ...detalle,
      precioUnitario,
      cantidadArticulo,
      descripcionPersonalizada,
      comentarios: detalle.comentarios || descripcionPersonalizada,
      importe: cantidadArticulo * precioUnitario,
    };

    if (!producto.idProductoArray) {
      producto.idProductoArray = nextIdProductoArray;
      nextIdProductoArray += 1;
    }

    return producto;
  });

  return {
    productos,
    nextIdProductoArray,
  };
};
